export const MsftTenantId = '72f988bf-86f1-41af-91ab-2d7cd011db47';
